export default __webpack_public_path__ + "bcad218cf54ebc01a2560fcd855b08ce.svg";